import { useAppSelector } from 'store/store';
import { TenantAdminRoles } from 'shared/permissions/roles';

export function useIsBottomFromTenantAdmin(): boolean {
  const groups = useAppSelector((state) => state.auth.groups);
  return groups?.some((role) => TenantAdminRoles.includes(role));
}
